import { useEffect, useEffectEvent } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actions, selectors } from "@containers/Cases/store";
import { PROCESSING_CASE_STATUSES } from "@shared/models";

const TIMEOUT = 10000; //10 sec
const MAX_POLLED_CASES = 50; //has to be in sync with the limit of the api

/**
 * Keeps the loaded cases up to date while any of them is still being processed, so that the user
 * does not have to reload the page to see a parsed file. Only the statuses and the parsed person
 * details are refetched and merged into the loaded cases, the list itself is left untouched to
 * keep the infinite scroll intact.
 */
const useRefreshCasesStatuses = () => {
  const dispatch = useDispatch();
  const cases = useSelector(selectors.getCasesList());

  const processingCaseIds = cases
    .filter((c) => PROCESSING_CASE_STATUSES.includes(c.status))
    .map((c) => c.id)
    .slice(0, MAX_POLLED_CASES);
  const hasProcessingCases = !!processingCaseIds.length;

  const refreshStatuses = useEffectEvent(() => {
    dispatch(actions.getCasesStatuses.request(processingCaseIds));
  });

  useEffect(() => {
    if (!hasProcessingCases) return;

    const intervalId = setInterval(() => {
      if (document.hidden) return;

      refreshStatuses();
    }, TIMEOUT);

    return () => clearInterval(intervalId);
  }, [hasProcessingCases]);
};

export default useRefreshCasesStatuses;
